import React, { useEffect, useLayoutEffect } from 'react';
import { UiToast } from 'components';
import { request, track, user } from 'lib';
import { useStateful } from 'react-hanger';
import { getGlobalStore } from 'stores';
// {
//     "publicPath": "https://im.2339.com/",
//     "entries": {
//         "app": {
//             "js": [
//                 "static/scripts/dll/app_dll_3db0c0.js",
//                 "static/scripts/app.63e5c7.bundle.js"
//             ],
//             "css": [
//                 "app.b15ac1bd.bundle.css"
//             ]
//         }
//     }
// }

const loadJs = (url) => {
  return new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.src = url;
    script.onload = () => {
      resolve();
    };
    script.onerror = () => {
      reject();
    };
    document.body.appendChild(script);
  });
};

const ImApp = () => {
  const imAssets = useStateful(null);

  useEffect(() => {
    setTimeout(() => {
      request.im
        .get('entry.json', {
          _t: Date.now(),
        })
        .then((res) => {
          imAssets.setValue(res.data);
          window.ImAppConfig = {
            inject: true,
            token: user.getToken(),
            updateUnreadCount: (count) => {
              getGlobalStore().setUnreadCount(count);
            },
          };

          if (window.ImApp) {
            return;
          }

          const publicPath = res.data.publicPath;
          const [dllJs, appJs] = res.data.entries.app.js;

          loadJs(publicPath + dllJs)
            .then(() => {
              loadJs(publicPath + appJs)
                .then(() => {
                  track.send({
                    event: 'imApp',
                    event_type: 'imAppLoadSuccess',
                    content: !!window.ImApp,
                  });
                  window.ImApp.init();
                })
                .catch((e) => {
                  console.log(
                    'im_app元素',
                    !!document.getElementById('im_app'),
                  );
                  console.error('加载app_js异常', e);
                  track.send({
                    event: 'imApp',
                    event_type: 'imAppLoadFail',
                    content: e,
                    desc: '加载app_js异常',
                  });
                  UiToast.fail('私聊模块初始化异常');
                });
            })
            .catch((e) => {
              console.error('加载dll_js异常', e);
              track.send({
                event: 'imApp',
                event_type: 'imAppLoadFail',
                content: e,
                desc: '加载dll_js异常',
              });
              UiToast.fail('私聊模块初始化异常');
            });
        })
        .catch((res) => {
          UiToast.fail('私聊模块加载异常');
          track.send({
            event: 'imApp',
            event_type: 'imAppLoadFail',
            content: res,
            desc: 'entry.json加载异常',
          });
        });
    }, 1000);
  }, []);

  return (
    <>
      <div id="im_app"></div>
      {imAssets.value &&
        imAssets.value.entries.app.css.map((item) => {
          return (
            <link
              rel="stylesheet"
              href={imAssets.value.publicPath + item}
              key={item}
            />
          );
        })}
    </>
  );
};

export default ImApp;
